import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Alumno, Evento} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiRutinasService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** rutinas ***/

  getRutinas(): Promise<Alumno[]> {
    const url = `${this.apiUrl}rutinas`;
    return firstValueFrom(this.http.get<Alumno[]>(url))
  }
  getSiestas(): Promise<Evento[]> {
    const url = `${this.apiUrl}rutinas/siestas`;
    return firstValueFrom(this.http.get<Evento[]>(url))
  }
  getAseos(): Promise<Evento[]> {
    const url = `${this.apiUrl}rutinas/aseos`;
    return firstValueFrom(this.http.get<Evento[]>(url))
  }
  getComidas(): Promise<Evento[]> {
    const url = `${this.apiUrl}rutinas/comida`;
    return firstValueFrom(this.http.get<Evento[]>(url))
  }
  getNoComidas(dest: string): Promise<Evento[]> {
    const url = `${this.apiUrl}rutinas/nocomida/${dest}`;
    return firstValueFrom(this.http.get<Evento[]>(url))
  }
  getSalidas(): Promise<Alumno[]> {
    const url = `${this.apiUrl}rutinas/salidas`;
    return firstValueFrom(this.http.get<Alumno[]>(url))
  }
  updateRutina(datos: {id: number, campo: string, valor: boolean}): Promise<any> {
    const url = `${this.apiUrl}rutinas/update/${datos.id}`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  updateSalida(id: number): Promise<any> {
    const url = `${this.apiUrl}rutinas/salida/${id}`;
    return firstValueFrom(this.http.post<any>(url, {}))
  }

}
